import { ParcelTrackingSearchParams } from '@app/models';
import { ParcelShopSearchParams } from '@app/models';
import { LanguageCode } from '@app/models/page';
import { ShippingCountryId } from '@app/models/prices';
import { createAction, props } from '@ngrx/store';

export const setParcelSearchParams = createAction('[Inputs] Set Parcel Search Params', props<{ params: ParcelTrackingSearchParams }>());

export const setParcelShopSearchParams = createAction('[Inputs] Set Parcel Shop Search Params', props<{ params: ParcelShopSearchParams }>());

export const setSelectedCountry = createAction('[Inputs] Set Selected Country', props<{ countryId: ShippingCountryId }>());

export const setProp = createAction('[UIState] Set', props<{ key: string; value: any }>());

export const setLanguage = createAction('[UIState] Set Language', props<{ language: LanguageCode }>());
